module.exports = __webpack_public_path__ + "img/soundninja.118a4445.webp";